import type { UseMutationOptions } from "@pinia/colada";

import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { getEnv, handleQuery, ky } from "@solvari/utils";

function useSubscribeToNewsletter() {
  return {
    mutation: handleQuery(({ email }) => {
      return ky.post(ziggyUnsafe("api.v3.newsletter.subscribeToAll"), {
        json: { email },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { "Solvari-Locale": getEnv().config.localeCode },
      });
    }),
  } satisfies UseMutationOptions<unknown, { email: string }>;
}

export { useSubscribeToNewsletter };
